import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/System/Reboot/SuccessBox';
import RebootTable from 'components/Web_User_Interface/1080p_Series/System/Reboot/rebootTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  RebootTable,
  BreadCrumbs,
  SEOHelmet,
  React
};